export const quizListTranslations = {
  en: {
    title: 'Test List',
    quizzes: [
      {
        id: 1,
        title: 'Grade 8 Math Test',
        description: 'Test basic algebra knowledge.',
        time: '30 minutes',
      },

    ],
    attempts: 'Attempts',
    time: 'Time',
    details: 'Details',
    start: 'Start'
  },
  vi: {
    title: 'Danh sách Bài kiểm tra',
    quizzes: [
      {
        id: 1,
        title: 'Bài kiểm tra Toán lớp 8',
        description: 'Kiểm tra kiến thức đại số cơ bản.',
        time: '30 phút',
      },
  
    ],
    attempts: 'Đã làm',
    time: 'Thời gian',
    details: 'Chi tiết',
    start: 'Bắt đầu'
  }
};